module.exports = __webpack_public_path__ + "static/media/MS.9f474a08.png";